<template>
    <div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
      <div class="w-full max-w-3xl lg:max-w-4xl space-y-4">
         <div class="flex w-full justify-center text-ihh-midnight-gray font-semibold text-3xl text-center mb-8">
           New Birth Kit Setup
         </div>
         <div class="text-ihh-slate-gray text-base">
            <div>We have a custom birth kit service that we offer to midwives and birth centers.  We will maintain your custom birth kit list on our website and your clients can order their birth kit directly from our website.</div>
            <div>Looking for your kit in our database?  Search <a href="/midwife-birth-kits/" class="text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2">here</a></div>
         </div>
         <div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-2xl sm:text-4xl text-start py-4">Benefits</div>
         <div class="px-4 text-ihh-slate-gray space-y-4">
             <ul class="list-disc space-y-1">
               <li>Allows you to focus on your clients and building your practice instead of spending time sourcing birth supplies.</li>
               <li>Offers a customizable landing page on our site for your birth kit.</li>
               <li>Allows your customers to easily purchase your kit and have it shipped directly to their home.</li>
               <li>Kits can be modified online which allows customers to remove or add items they already have or need.</li>
               <li>Allows you to focus on your clients and building your practice
                instead of spending time sourcing birth supplies.</li>
             </ul>
             <div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-2xl sm:text-4xl text-start py-4">Want to chat?</div>
             <div>Prefer to talk on the phone with us first about this service? Schedule a quick call with us <a target="_blank" href="https://calendly.com/inhishands" class="text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2">here</a>!</div>
             <div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-2xl sm:text-4xl text-start py-4">Getting Started</div>
             <div>To get started setting your custom kit please fill out the form below. We will follow up with you by email as soon as your kit is setup for you to review and make any changes you need.</div>


             <div class="">
                <iframe
                    ref="typeformIframe"
                    src="https://form.typeform.com/to/oHOZiK"
                    frameborder="0"
                    width="100%"
                    height="500px"
                    @load="handleIframeLoad"
                ></iframe>
             </div>
      </div>
</div>

      <!-- Messenger icon -->
<!-- <svg width="28" height="28" viewBox="0 0 100 100" fill="none" role="img" aria-label="Bubble icon button" xmlns="http://www.w3.org/2000/svg">
        <path fill="#161616" filter="#33c9df204aeec9aa096f1fd360bd4160" d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50h30.8l0-10.6C92.5,80.2,100,66,100,50C100,22.4,77.6,0,50,0z M32,54.5 c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C36.5,52.5,34.5,54.5,32,54.5z M50,54.5c-2.5,0-4.5-2-4.5-4.5 c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5C54.5,52.5,52.5,54.5,50,54.5z M68,54.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 s4.5,2,4.5,4.5C72.5,52.5,70.5,54.5,68,54.5z"></path>
      </svg> -->

      <!-- X icon -->
<!-- <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.35 6.66166C20.895 6.20666 20.16 6.20666 19.705 6.66166L14 12.355L8.295 6.65C7.84 6.195 7.105 6.195 6.65 6.65C6.195 7.105 6.195 7.84 6.65 8.295L12.355 14L6.65 19.705C6.195 20.16 6.195 20.895 6.65 21.35C7.105 21.805 7.84 21.805 8.295 21.35L14 15.645L19.705 21.35C20.16 21.805 20.895 21.805 21.35 21.35C21.805 20.895 21.805 20.16 21.35 19.705L15.645 14L21.35 8.295C21.7933 7.85166 21.7933 7.105 21.35 6.66166Z" fill="#161616"></path>
      </svg> -->

      <!-- Clock icon -->
<!-- <svg width="12" height="12" viewBox="0 0 12 12" fill="none" data-qa="animated-clock" class="ClockSVG-sc-__sc-1j3qdaw-0 iFObvB">
    <circle cx="6" cy="6" fill="#3D3D3D" r="6"></circle>
    <line x1="6" y1="6" x2="6" y2="3" stroke="#FFFFFF" stroke-width="1.2" stroke-linecap="round"></line>
    <line x1="6" y1="6" x2="6" y2="3" stroke="#FFFFFF" stroke-width="1.2" stroke-linecap="round" id="clock-hour-hand"></line></svg> -->



    </div>
</template>

<script>
export default {
    methods: {
        handleIframeLoad() {
            // When iframe loads, restore the scroll position to top of page
            this.$nextTick(() => {
                // Force scroll back to top
                window.scrollTo(0, 0);
            });
        },
    },
    
    mounted() {
        // Prevent auto-scrolling by setting up a MutationObserver
        this.$nextTick(() => {
            // Create a MutationObserver to watch for changes to the iframe
            const observer = new MutationObserver(() => {
                // Force scroll back to top whenever iframe changes
                window.scrollTo(0, 0);
            });

            // Start observing the iframe for attribute changes
            if (this.$refs.typeformIframe) {
                observer.observe(this.$refs.typeformIframe, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });

                // Also set up a scroll event handler for the first few seconds
                const scrollHandler = () => {
                    window.scrollTo(0, 0);
                };

                window.addEventListener('scroll', scrollHandler);

                // Remove the scroll handler after 3 seconds
                setTimeout(() => {
                    window.removeEventListener('scroll', scrollHandler);
                    observer.disconnect();
                }, 3000);
            }
        });
    },
}
</script>
